import React from "react";
import { MainContainer } from "./styles/sharedStyles"; // Import shared styles
import Title from "../components/title/Title";
import TextParagraph from "../components/text/TextParagraph";

const paragraph1 = `
    Cette section est en cours de développement ✨
    <br><br>
    Je travaille en ce moment sur le premier ebook.
  `;

const Ebook = () => {
  return (
    <MainContainer>
      <Title title="Ebooks" summary="Les Ebooks disponibles" />

      <TextParagraph content={paragraph1} />
    </MainContainer>
  );
};

export default Ebook;
